import { object, number, z, string, date } from "zod";

export const CreatePhoneCallQueryParams = object({
  ladyId: number(),
  manPhone: string(),
  callTime: date(),
  timeZone: string(),
  manCallTime: string(),
  ladyCallTime: string(),
});

export type CreatePhoneCallQueryParams = z.infer<
  typeof CreatePhoneCallQueryParams
>;
